module.exports = __webpack_public_path__ + "media/packs/images/flags/TD-b63501eda59fef2ca5ead40c0d59768f.svg";